import React from "react";
import { useT } from "@al/next/al-ex";

import ErrorBlock, { ErrorBlockProps } from "../../ErrorBlock";

import no_coupon_img from "./no_coupon.png";

export function NoCoupon(props: ErrorBlockProps): JSX.Element {
  const t = useT();
  return <ErrorBlock {...props} imgSrc={no_coupon_img} text={t("global:没有优惠券")} hideBtn />;
}
